module.exports = __webpack_public_path__ + "h5/img/di11.1d4cf6b5.png";